import type { MlpCampaignPrefill } from './mlp-campaign-url.helper';
import { buildMlpCampaignUrl } from './mlp-campaign-url.helper';

export type MlpCallbackContext = 'fragebogen' | 'entscheidung';

const CAMPAIGN_IDS: Record<MlpCallbackContext, string> = {
  fragebogen: 'c202526KFZReEing',
  entscheidung: 'c202527KFZReEnt',
};

export function buildMlpCallbackUrl(
  context: MlpCallbackContext,
  prefill: MlpCampaignPrefill = {},
  date = new Date()
): string {
  return buildMlpCampaignUrl(CAMPAIGN_IDS[context], prefill, date);
}
